import React from 'react';
import PropTypes from 'prop-types';
import { useFela } from 'react-fela';
import { largeScreen, smallScreen } from '../../../../common/mixins';

const seekButtonRules = ({ theme, enabled, isMobile }) => ({
  color: theme.color.light,
  cursor: enabled ? 'pointer' : 'default',
  height: theme.iconHeight.large,
  opacity: enabled ? theme.opacity.enabled : theme.opacity.disabled,
  transition: theme.transition.default,
  willChange: 'opacity',
  ':hover': {
    opacity: enabled ? theme.opacity.hovered : theme.opacity.disabled,
  },
  extend: [
    {
      condition: isMobile,
      style: {
        height: '30px',
        width: '30px',
        opacity: enabled ? theme.opacity.hovered : theme.opacity.disabled,
      },
    },
    {
      condition: !isMobile,
      style: {
        extend: [
          largeScreen({
            height: theme.iconHeight.medium,
          }),
          smallScreen({
            height: theme.iconHeight.small,
          }),
        ],
      },
    },
  ],
});

export const SeekButton = ({ enabled, isMini, isMobile, ...otherProps }) => {
  const { css } = useFela({ enabled, isMobile });

  return (
    <svg className={css(seekButtonRules)} {...otherProps} />
  );
};

SeekButton.propTypes = {
  enabled: PropTypes.bool,
  isMini: PropTypes.bool,
  isMobile: PropTypes.bool,
};

const textRules = ({ theme }) => ({
  fill: 'currentColor',
  fontSize: theme.fontSize.fine,
});

export const Text = (props) => {
  const { css } = useFela();

  return (
    <text className={css(textRules)} {...props} />
  );
};
